{{#each . delimeter="\n"}}
if ({{ identifier }} == {{ defaultValue }}) begin
  `uvm_fatal(get_type_name(), "Must constrain {{ identifier }}.")
end
{{/each}}
